import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=409cff42&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=409cff42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409cff42",
  null
  
)

export default component.exports